import { render, staticRenderFns } from "./BugReportForm.vue?vue&type=template&id=0d57a960&scoped=true"
import script from "./BugReportForm.vue?vue&type=script&lang=js"
export * from "./BugReportForm.vue?vue&type=script&lang=js"
import style0 from "./BugReportForm.vue?vue&type=style&index=0&id=0d57a960&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d57a960",
  null
  
)

export default component.exports